/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Bump_DaysInputs */

const cs_portals_bump_days = /** @type {(inputs: Portals_Bump_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dny`)
};

const en_portals_bump_days = /** @type {(inputs: Portals_Bump_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Days`)
};

/**
* | output |
* | --- |
* | "Days" |
*
* @param {Portals_Bump_DaysInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_bump_days = /** @type {((inputs?: Portals_Bump_DaysInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Bump_DaysInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_bump_days(inputs)
	return cs_portals_bump_days(inputs)
});